import { AxiosRestApplicationClient } from '@g2-shared/api-client/generated/web-clients-workspace-app';
import { generateBaseAxiosClient } from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

const WebClientWorkspacesApiClient = new AxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface IDIContext {
  WebClientWorkspacesApiClient: AxiosRestApplicationClient;
}

export const DIContext: IDIContext = {
  WebClientWorkspacesApiClient,
};
